const registeredFunctions = {}
export default registeredFunctions
